import {useQuery} from 'react-query'

import {auth} from '../../../utils/firebase'
import {UserService} from '../index'

export const useUser = () => useQuery(UserService.queries.getUserQuery({cacheTime: 0, params: {id: auth.currentUser?.uid}}))